<template>
    <div class="wrapper">
            <div class="sidebar" data-color="blue">
                <div class="sidebar-wrapper">
                    <div class="logo">
                        <a href="dashboard.php" class="simple-text">
                            Click2Date
                        </a>
                    </div>
                    <ul class="nav">
                        <li class="nav-item active" style="width: 100%; margin: 0;">
                            <router-link class="nav-link" to="/admin/dashboard">
                                <i class="nc-icon  nc-atom"></i>
                                <p>Dashboard</p>
                            </router-link>
                        </li>
                        
                        <li class="nav-item active" style="width: 100%; margin: 0;">
                            <router-link class="nav-link" to="/admin/employees">
                                <i class="nc-icon nc-tag-content"></i>
                                <p>Employees</p>
                            </router-link>
                        </li>
                        <!--
                        <li class="nav-item active" style="width: 100%; margin: 0; position: absolute; left: 0; bottom: 25px;">
                            <a @click="logout" class="nav-link" style="cursor: pointer;" to="/admin/employees">
                                <i class="nc-icon nc-simple-remove"></i>
                                <p>Logout</p>
                            </a>
                        </li>
                        -->
                    </ul>
                </div>
            </div>
            <div class="main-panel">
                <!-- Navbar -->
                <nav class="navbar navbar-expand-lg " color-on-scroll="500">
                    <div class=" container-fluid  ">
                        <a class="navbar-brand" href="#" style="width: 100%;"> Employees </a>
                            <span class="navbar-toggler-bar burger-lines"></span>
                            <span class="navbar-toggler-bar burger-lines"></span>
                            <span class="navbar-toggler-bar burger-lines"></span>
                        <div class="collapse navbar-collapse justify-content-end" id="navigation">
                            <b-alert variant="success"
                                    dismissible
                                    :show="showDismissibleAlert"
                                    @dismissed="showDismissibleAlert=false">
                                Gespeichert!
                            </b-alert>
                        </div>
                    </div>
                </nav>
                <!-- End Navbar -->
                <div class="content">
                    <div class="container-fluid">
                        <b-col>
                            <EmployeeModal @employeeSaved="employeeSaved" @close="closeModal" v-show="this.showEmployeeModal" 
                            :Employee="this.selectedEmployee" HeaderTitle="Edit Employee" :InitName="this.selectedEmployee.Name"></EmployeeModal>
                            <h2 v-show="this.tableData.length == 0">Loading ...</h2>
                            <transition name="fade">
                            <table-component
                                v-show="this.tableData.length > 0"
                                :data="this.tableData"
                                sort-by="EmployeeID"
                                sort-order="asc"
                                table-class="table table-striped"
                                filter-input-class="form-control filter-input"
                                filter-placeholder="Durchsuchen ..."
                                filter-no-results="Keine Ergebnisse">
                                <table-column show="EmployeeID" label="Id"></table-column>
                                <table-column show="Name" label="Name"></table-column>
                                <table-column show="BranchID" label="Branch Id"></table-column>
                                <table-column show="CompanyID" label="Company Id"></table-column>
                                <table-column label="" :sortable="false" :filterable="false">
                                    <template slot-scope="row">
                                        <b-button style="float: right; margin-left: 5px;" :data-id="`${row.EmployeeID}`" variant="danger">X</b-button>
                                        <b-button style="float: right;" :data-id="`${row.EmployeeID}`" @click="editEmployee" variant="primary">Bearbeiten</b-button>
                                        
                                    </template>
                                </table-column>
                            </table-component>
                            </transition>
                        </b-col>
                    </div>
                </div>
                <footer class="footer">
                    <div class="container">
                        <nav>
                        
                            <p class="copyright text-center">
                                ©
                                2018
                                CLICK2Date, ein Service von <a href="https://ipro.de">Ipro GmbH</a>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
</div>
</template>


<script>

import '../assets/demo.css'
import '../assets/light-bootstrap-dashboard.css'

import PictureInput from "vue-picture-input";
import EmployeeModal from "@/components/EmployeeModal";

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

export default {
  name: "DashboardView",
  components: {
    PictureInput,
    EmployeeModal
  },
  data() {
    return {
      customizeData : {},
      companyID: "-1",
      noAccessURL: process.env.NOACCESSURL,
      showDismissibleAlert: false,
      showEmployeeModal: false,
      tableData : [],
      selectedEmployee: {}
    };
  },
  methods: {
    onLoad: function() {
        this.companyID =  this.$localStorage.get('CompanyID');

        if(!this.companyID)
        {
            this.$router.push({ name: "ErrorView", params: { ErrorHeader: "NOT AUTHENTICATED", ErrorSubHeader: "Token fehlt."}});
            return;
        }

        this.loadCompanyInfo();


    },
    loadCompanyInfo: function()
    {
        this.$http.get(this.noAccessURL + 'getAppointment.php?action=personalize&companyId=' + this.companyID).then(response => {

          this.customizeData = response.body[0];
          console.log(this.customizeData);
        }, response => 
        {
          // error callback
        });

        this.$http.get(this.noAccessURL + 'getAppointment.php?action=employees&companyId=' + this.companyID).then(response => {

          this.tableData = response.body;
          console.log(this.tableData);
        }, response => 
        {
          // error callback
        });
    },
    newEmployee: function ()
    {

    },
    editEmployee: function (e)
    {
        var id = e.target.dataset.id;
        console.log(id);

        this.selectedEmployee = {};

        for(var i = 0; i < this.tableData.length; i++)
        {
            var em = this.tableData[i];

            if(em.EmployeeID == id)
            {
                this.selectedEmployee = em;
            }
        }

        this.showEmployeeModal = true;

    },
    closeModal: function ()
    {
        this.showEmployeeModal = false;
        this.selectedEmployee = {};
    },
    employeeSaved: function()
    {
        this.showEmployeeModal = false;
        this.tableData = [];
        this.$http.get(this.noAccessURL + 'getAppointment.php?action=employees&companyId=' + this.companyID).then(response => {

          this.tableData = response.body;
          console.log(this.tableData);
        this.selectedEmployee = {};
        }, response => 
        {
          // error callback
        });
    },
    logout: function ()
    {
        this.$localStorage.remove("CompanyID");
        this.$router.push({ name: "ErrorView", params: { ErrorHeader: "Log Out erfolgreich", ErrorSubHeader: "Bis bald!"}  });
    }
   
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #929292;
}

#LandingText
{
  text-align: left;
  margin-left: 15px;
}

#LandingMessage
{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/EmployeesEditView.vue